if (!customElements.get("shoppable-drawer")) {
  customElements.define(
    "shoppable-drawer",
    class ShoppableDrawer extends HTMLElement {
      constructor() {
        super();
        this.clickHandler = this.clickHandler.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.updateEventListeners = this.updateEventListeners.bind(this);
        this.handleHideTooltips = this.handleHideTooltips.bind(this);
        this.deviceType = "";
        this.isOpen = false;
      }

      connectedCallback() {
        this.body = document.querySelector("body");
        const parentBody = this.closest(".shoppable-image__body");
        this.container = parentBody.querySelector(".wt__shoppable-image");
        this.wrapper = parentBody.querySelector(".wt__shoppable-image--wrapper");
        this.shoppableBody = parentBody;
        this.shoppableImagesBody = document.querySelectorAll(".shoppable-image__body");
        this.pageOverlay = parentBody.querySelector(".wt__shoppable-image--page-overlay");
        this.productContent = this.querySelector(".wt-dot__link");
        this.tooltip = this.querySelector(".wt-dot__tooltip");
        this.button = this.querySelector(".wt-dot__circle");
        this.closeButton = parentBody.querySelector(".wt-options__title svg");

        this.updateEventListeners();

        this.shoppableImagesBody.forEach((link) => {
          this.handleAddListenerToHideTooltips(link);
        });

        window.addEventListener("resize", this.handleResize);
        document.addEventListener("click", this.handleHideTooltips);

        this.button?.addEventListener("click", (event) => {
          event.stopPropagation();
          if (this.matchResolution() === "mobile") {
            this.clickHandler();
          } else {
            this.handleDotClick(event);
          }
        });

        this.closeButton?.addEventListener("click", this.closeHandler);
      }

      handleDotClick = (event) => {
        event.preventDefault();
        const dot = event.target.closest(".wt-dot");
        if (dot) {
          this.toggleTooltip(dot.nextElementSibling);
        }
      };

      handleDotKeydown = (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          const dot = event.target.closest(".wt-dot");
          if (dot) {
            this.toggleTooltip(dot.nextElementSibling);
          }
        }
      };

      toggleTooltip(tooltip) {
        this.hideAllTooltips();
        if (
          window.getComputedStyle(tooltip).getPropertyValue("visibility") === "hidden"
        ) {
          this.showTooltip(tooltip);
        }
      }

      hideAllTooltips() {
        document.querySelectorAll(".wt-dot__tooltip").forEach((tooltip) => {
          tooltip.style.visibility = "hidden";
          tooltip.style.opacity = 0;
        });
      }

      showTooltip(tooltip) {
        tooltip.style.visibility = "visible";
        tooltip.style.opacity = 1;
      }

      handleResize = () => {
        this.updateEventListeners();
      };

      handleAddListenerToHideTooltips(link) {
        link.addEventListener("click", (event) => {
          if (this.isClickOutside(event)) {
            this.hideTooltips();
          }
        });
      }

      handleRemoveListenerToHideTooltips(link) {
        link.removeEventListener("click", (event) => {
          if (this.isClickOutside(event)) {
            this.hideTooltips();
          }
        });
      }

      handleHideTooltips(event) {
        let isInsideShoppableBody = event.target.closest(".shoppable-image__body");
        if (!isInsideShoppableBody) {
          this.hideTooltips();
        }
      }

      hideTooltips() {
        if (this.matchResolution() === "mobile") {
          this.closeHandler();
        } else {
          document.querySelectorAll(".wt-dot__tooltip").forEach((tooltip) => {
            tooltip.style.visibility = "hidden";
            tooltip.style.opacity = 0;
          });
        }
      }

      isClickOutside(event) {
        return !(
          event.target.classList.contains("wt-dot__circle") ||
          event.target.classList.contains("wt-dot__ringing") ||
          event.target.closest(".wt-dot__tooltip")
        );
      }

      updateEventListeners() {
        if (this.matchResolution() === "mobile" && this.matchResolution() !== this.deviceType) {
          if (this.tooltip) this.tooltip.style.display = "none";
          this.deviceType = this.matchResolution();
        } else if (this.matchResolution() === "desktop" && this.matchResolution() !== this.deviceType) {
          this.closeHandler();
          if (this.tooltip) this.tooltip.style.display = "initial";
          this.deviceType = this.matchResolution();
        }
      }

      clickHandler() {
        this.wrapper.querySelectorAll(".wt-dot__link")?.forEach((element) => {
          element.remove();
        });
        this.body.classList.add("shoppable-image-on");
        this.isOpen = true;
        this.pageOverlay.classList.remove("hidden");
        const productContentClone = this.productContent.cloneNode(true);
        this.wrapper.appendChild(productContentClone);
        this.wrapper.classList.add("open");
      }

      closeHandler() {
        if (this.body?.classList.contains("shoppable-image-on"))
          this.body.classList.remove("shoppable-image-on");
        if (!this.pageOverlay?.classList.contains("hidden"))
          this.pageOverlay.classList.add("hidden");
        if (this.wrapper?.classList.contains("open"))
          this.wrapper.classList.remove("open");
      }

      matchResolution() {
        return window.innerWidth < 900 ? "mobile" : "desktop";
      }

      disconnectedCallback() {
        this.closeButton?.removeEventListener("click", this.closeHandler);
        window.removeEventListener("resize", this.handleResize);
        this.shoppableImagesBody?.forEach((link) => {
          this.handleRemoveListenerToHideTooltips(link);
        });
        document.removeEventListener("click", this.handleHideTooltips);
      }
    }
  );
}